<template>
    <div>
        <span v-for="n in fullStars" class="icon ion-ios-star star-icon"></span><span v-if="hasHalfStar" class="icon ion-ios-star-half star-icon"></span>
    </div>
</template>

<script>
  export default {
    name: "Stars",
    props: {
      stars: Number,
    },
    computed: {
      fullStars(){
        return parseInt(this.stars);
      },
      hasHalfStar(){
        return parseFloat(this.stars) % 1 !==0;
      }
    }
  }
</script>

<style scoped>
    .star-icon {
        z-index: 10;
        color: white;
        padding: 0.1rem;
        text-align: center;
        font-size: 1.1rem;
        font-family: "Barlow Condensed", Helvetica, sans-serif;
        text-shadow: 0 0 5px rgba(0, 0, 0, 1);
    }
</style>